(() => {
  if (window.Shopify?.theme?.role !== 'unpublished') return;
  const preview = new URL('https://llovable.com/pages?preview_key=c6af02e025205138c0ca6c04332dd26d');
  preview.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
  preview.searchParams.set('pb', '0');
  document.querySelectorAll('[data-lln-faq-link]').forEach(link => { link.href = preview.href; });
  const penPreview = new URL('https://llovable.com/products_preview?preview_key=26c70484f843643769a000b4c6dcc0e9');
  penPreview.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
  penPreview.searchParams.set('pb', '0');
  document.querySelectorAll('[data-lln-meet-link]').forEach(link => { link.href = penPreview.href; });
  const howPreview = new URL('https://llovable.com/pages?preview_key=ff45d8f4c66c1df9c43f2d6d988f598d');
  howPreview.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
  howPreview.searchParams.set('pb', '0');
  document.querySelectorAll('[data-lln-how-link]').forEach(link => { link.href = howPreview.href; });
  const kitPreview = new URL('https://llovable.com/products_preview?preview_key=beecb5a543d5d58df65e2a63a60522d0');
  kitPreview.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
  kitPreview.searchParams.set('pb', '0');
  document.querySelectorAll('[data-lln-kit-link]').forEach(link => { link.href = kitPreview.href; });
  const offersPreview = new URL('https://llovable.com/products_preview?preview_key=26c70484f843643769a000b4c6dcc0e9');
  offersPreview.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
  offersPreview.searchParams.set('pb', '0');
  offersPreview.searchParams.set('view', 'nail-bundles');
  document.querySelectorAll('[data-lln-offers-link],[data-lln-offer-nail-link]').forEach(link => { link.href = offersPreview.href; });
  const lipOffersPreview = new URL('https://llovable.com/products_preview?preview_key=bbd1a768d4b6fb734a3de764c7cd62af');
  lipOffersPreview.searchParams.set('preview_theme_id', String(window.Shopify.theme.id));
  lipOffersPreview.searchParams.set('pb', '0');
  lipOffersPreview.searchParams.set('view', 'lip-bundles');
  document.querySelectorAll('[data-lln-offer-lip-link]').forEach(link => { link.href = lipOffersPreview.href; });
})();


